import { useCallback } from 'react';
import { useLocalStorage } from 'shared/hooks/use-local-storage';

/**
 * Настройку выставляют один раз под свою сцену в OBS, поэтому она переживает
 * перезагрузку страницы: держим её в localStorage, а не в состоянии страницы.
 */
const HIDE_PANEL_CONFIG = {
  hidePanel: {
    key: 'devicesOverlayHidePanel',
    defaultValue: false,
    parser: (value: string) => value === 'true',
  },
};

/** Подставлять ли `hidePanel=true` в копируемую ссылку на табло — оверлей откроется без джойстика. */
export function useHidePanelOption() {
  const [values, setValues] = useLocalStorage(HIDE_PANEL_CONFIG);

  const setHidePanel = useCallback((value: boolean) => setValues({ hidePanel: value }), [setValues]);

  return { hidePanel: values.hidePanel, setHidePanel };
}
